import {Suspense} from 'react';
import {Outlet} from 'react-router-dom';
import {Helmet} from "react-helmet";
import "./style.scss";
import details from "@constants/shopDetails";

const EmptyLayout = () => {
    return (
        <div
            className="empty-layout">
            <Suspense fallback={null}>
                <main className="empty-layout-content">
                    <Helmet>
                        <title>{details.name}</title>
                    </Helmet>

                    <Outlet/>
                </main>
            </Suspense>
        </div>
    );
};

export default EmptyLayout;
